import {
  AUTO_PATH_SOURCE,
  AUTO_PATH_LAYER,
  CUSTOM_PATH_SOURCE,
  CUSTOM_PATH_LAYER,
  POINTS_CIRCLE_LAYER
} from './constants';
import { safeSetSourceData } from './utils';
import { debug } from '../../../utils/debug';
import { pathToGeoJSON } from '../utils/mapUtils';

// Update auto path data
export const updateAutoPath = ({
  map,
  mapReady,
  sourcesReady,
  autoPath,
  locations,
  shouldShowAutoPath
}) => {
  debug('TSP-PATH', 'Updating auto path', { pathLength: autoPath?.length || 0 });

  if (!autoPath || autoPath.length === 0) {
    debug('TSP-PATH', 'Clearing auto path data');
    try {
      if (map.getSource(AUTO_PATH_SOURCE)) {
        map.getSource(AUTO_PATH_SOURCE).setData({
          type: 'FeatureCollection',
          features: []
        });
      }
    } catch (err) {
      debug('TSP-PATH', 'Error clearing auto path', err);
    }
    return;
  }

  if (!mapReady || !map.getSource(AUTO_PATH_SOURCE)) {
    debug('TSP-PATH', 'Map or sources not ready, skipping update');
    return;
  }

  try {
    const pathData = pathToGeoJSON(autoPath, locations);
    
    if (pathData.features.length === 0) {
      debug('TSP-PATH', 'Not enough valid coordinates to render path');
      return;
    }

    map.getSource(AUTO_PATH_SOURCE).setData(pathData);
    debug('TSP-PATH', 'Auto path updated successfully');

  } catch (err) {
    debug('TSP-PATH', 'Error updating auto path', err);
  }
};

// Update custom path data
export const updateCustomPath = ({
  map,
  mapReady,
  sourcesReady,
  customPath,
  locations,
  shouldShowCustomPath
}) => {
  debug('TSP-PATH', 'Updating custom path', { pathLength: customPath?.length || 0 });

  if (!customPath || customPath.length === 0) {
    debug('TSP-PATH', 'Clearing custom path data');
    try {
      if (map.getSource(CUSTOM_PATH_SOURCE)) {
        map.getSource(CUSTOM_PATH_SOURCE).setData({
          type: 'FeatureCollection',
          features: []
        });
      }
    } catch (err) {
      debug('TSP-PATH', 'Error clearing custom path', err);
    }
    return;
  }

  if (!mapReady || !map.getSource(CUSTOM_PATH_SOURCE)) {
    debug('TSP-PATH', 'Map or sources not ready, skipping custom path update');
    return;
  }

  try {
    const pathData = pathToGeoJSON(customPath, locations);

    if (pathData.features.length === 0) {
      debug('TSP-PATH', 'Not enough valid coordinates for custom path');
      return;
    }

    map.getSource(CUSTOM_PATH_SOURCE).setData(pathData);
    debug('TSP-PATH', 'Custom path updated successfully');

  } catch (err) {
    debug('TSP-PATH', 'Error updating custom path', err);
  }
};

// Update path visibility
export const setPathVisibility = ({ map, pathType, visible }) => {
  try {
    if (!map || typeof map.getLayer !== 'function') {
      debug('TSP-PATH', 'Map not ready for setPathVisibility');
      return;
    }
    
    const layerId = pathType === 'auto' ? AUTO_PATH_LAYER : CUSTOM_PATH_LAYER;
    if (map.getLayer(layerId)) {
      map.setLayoutProperty(layerId, 'visibility', visible ? 'visible' : 'none');
      debug('TSP-PATH', `Set ${pathType} path visibility to ${visible}`);
    }
  } catch (err) {
    debug('TSP-PATH', 'Error setting path visibility', err);
  }
};

// Update points visibility
export const updatePointsVisibility = ({ map, showPoints }) => {
  try {
    if (map.getLayer(POINTS_CIRCLE_LAYER)) {
      map.setLayoutProperty(
        POINTS_CIRCLE_LAYER,
        'visibility',
        showPoints ? 'visible' : 'none'
      );
    }
  } catch (err) {
    debug('TSP-PATH', 'Error updating points visibility', err);
  }
};

// Clean up resources
export const cleanupPathRenderer = () => {
  debug('TSP-PATH', 'Cleaning up path renderer');
  // Simple cleanup - no complex memory management
};